export const TASK_LOGS_FETCHED = 'TASK_LOGS_FETCHED';
export const SCRAPER_TASK_FETCHED = 'SCRAPER_TASK_FETCHED';
export const SCRAPER_LOGS_CLEAR = 'SCRAPER_LOGS_CLEAR';
export const SCRAPER_TASK_LOAD_MORE = 'SCRAPER_TASK_LOAD_MORE';
export const ADD_PENDING_RESTART_LOG = 'ADD_PENDING_RESTART_LOG';
export const REMOVE_PENDING_RESTART_LOG = 'REMOVE_PENDING_RESTART_LOG';
export const ADD_RESTARTED_TASK = 'ADD_RESTARTED_TASK';
